import type {Competition} from "@/hooks/useCompetitions.ts";
import {format} from "date-fns";

export default function CompetitionCard({
                                            comp,
                                            onClick,
                                        }: {
    comp: Competition;
    onClick?: () => void;
}) {

    const placeholder = "https://placehold.co/600x400";
    const img = (comp as any).imageUrl || placeholder;

    return (
        <article key={comp.id} className="flex flex-col items-start justify-between">

            <div onClick={onClick}
                 className="relative w-full cursor-pointer">
                <img
                    alt={comp.title}
                    src={img}
                    className="w-full rounded-2xl bg-gray-100 object-cover aspect-video sm:aspect-[2/1] lg:aspect-[3/2]"
                    loading="lazy"
                    decoding="async"
                />
                <div className="absolute inset-0 rounded-2xl ring-1 ring-gray-900/10"/>
            </div>

            <div className="flex max-w-xl grow fkex flex-col justify-between">
                <div className="mt-8 flex items-center gap-x-4 text-xs">
                    <time dateTime={comp.startAt} className="text-gray-500">
                        Begin: {format(new Date(comp.startAt), 'MMM d, yyyy HH:mm')}
                    </time>

                    <time dateTime={comp.endAt} className="text-gray-500">
                        Einde: {format(new Date(comp.endAt), 'MMM d, yyyy HH:mm')}
                    </time>

                </div>

                <div onClick={onClick}
                     className="group relative grow cursor-pointer">
                    <h3 className="mt-3 text-lg/6 font-semibold text-blue-900 group-hover:text-gray-600">
                        <span className="absolute inset-0" aria-hidden="true"/>
                        {comp.title}
                    </h3>
                    <p className="mt-5 line-clamp-3 text-sm/6 text-gray-600">
                        {comp.description}
                    </p>
                </div>
            </div>

        </article>
    );
}
